import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { LenisContext } from "./components/landing/lenis-context";
import Navbar from "./components/landing/Navbar";
import Hero from "./components/landing/Hero";
import Marquee from "./components/landing/Marquee";
import Manifesto from "./components/landing/Manifesto";
import Services from "./components/landing/Services";
import BeforeAfter from "./components/landing/BeforeAfter";
import Gallery from "./components/landing/Gallery";
import Testimonials from "./components/landing/Testimonials";
import ServiceAreas from "./components/landing/ServiceAreas";
import FAQ from "./components/landing/FAQ";
import Booking from "./components/landing/Booking";
import Footer from "./components/landing/Footer";
import FloatingWhatsApp from "./components/landing/FloatingWhatsApp";

export default function App() {
  const [lenis, setLenis] = useState(null);

  useEffect(() => {
    const instance = new Lenis({ duration: 1.15, smoothWheel: true });
    setLenis(instance);
    let rafId;
    const loop = (time) => {
      instance.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      instance.destroy();
    };
  }, []);

  return (
    <LenisContext.Provider value={lenis}>
      <div className="min-h-screen overflow-x-hidden bg-white font-sans text-slate-900 antialiased">
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Manifesto />
          <Services />
          <BeforeAfter />
          <Gallery />
          <Testimonials />
          <ServiceAreas />
          <FAQ />
          <Booking />
        </main>
        <Footer />
        <FloatingWhatsApp />
      </div>
    </LenisContext.Provider>
  );
}
